import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { LensDownstreamWorkbooksQueryVariables, LensDownstreamWorkbooksQuery, WorkbooksDisplayGridRowDataFragment, WorkbookSortOrder , LensDownstreamWorkbooksDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper
} from '../../../data-catalog-shared';
import {
  getRowDataForWorkbook,
  WorkbooksDisplayGrid,
  WorkbooksDisplayGridRowData
} from '../sharedDisplayGrid/WorkbooksDisplayGrid';
import { WorkbooksValidSortFields } from '../sorting/sortProviders/WorkbooksGridSortProvider';

type QueryVariables = LensDownstreamWorkbooksQueryVariables;
type QueryResults = LensDownstreamWorkbooksQuery;
type QueryResultListNode = WorkbooksDisplayGridRowDataFragment;
type GridRowData = WorkbooksDisplayGridRowData;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData?.lenses && resultData.lenses[0]?.downstreamWorkbooksConnection;
}

export type LensDownstreamWorkbooksQueryGridProps =
  GridSortProps<WorkbooksValidSortFields> & {
    readonly vizportalUrlId: string;
    readonly rowCount: number | null;
  };

export function LensDownstreamWorkbooksQueryGrid(props: LensDownstreamWorkbooksQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamWorkbooksLineageGridMessage();

  return <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
    queryGql={LensDownstreamWorkbooksDocument}
    partialQueryVariables={{ vizportalUrlId: props.vizportalUrlId, orderBy: props.orderBy as WorkbookSortOrder }}
    selectConnectionListResult={selectConnectionListResult}
    mapResultNode={getRowDataForWorkbook}
  >
    {({ rowStore }) => <WorkbooksDisplayGrid
      rowStore={rowStore}
      emptyGridMessage={emptyGridMessage}
      rowCount={props.rowCount}
      orderBy={props.orderBy}
      updateSortOrder={props.updateSortOrder}
    />}
  </PaginatedQueryWrapper>;
}
